// src/apiService.js
import axios from 'axios';
import API_BASE_URL from './apiConfig';

// Set up axios instance with default settings
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${localStorage.getItem('token')}`,
  },
});

const buildQueryString = (params: any) => {
  let queryParams = '?offset=' + params.offset + '&limit=' + params.limit;
  if (params.sort) {
      if (params.sort.length > 0) {
          let sortString = '';
          params.sort.forEach( (value:any) => {
              if (sortString.length > 0) {
                  sortString += ',';
              }
              sortString += value.field + '|' + value.order;
          });
          queryParams += '&sortby=' + sortString;
      }
  }
  if (params.filters) {
      let filterString = '';
      params.filters.forEach( (filter:any) => {
          let fieldString = '';
          filter.forEach( (field: any) => {
              if (fieldString.length > 0) {
                  fieldString += ',';
              }
              fieldString += field.property + '|' + field.operator + '|' + field.value;
          });
          if (fieldString.length > 0) {
              fieldString = '(' + fieldString + ')';
          }
          if (filterString.length > 0) {
              filterString += ',';
          }
          filterString += fieldString;
      });
      queryParams += '&filter=' + encodeURIComponent(filterString);
  }
  if (params.expand) {
      queryParams += '&expand=' + params.expand;
  }
  return queryParams;
}

// Function to handle uproject creation
export const createProject = async (data: any) => {
  try {
    const response = await api.post('/projects', data);
    return response.data;
  } catch (error) {
    console.error('Error creating uproject:', error);
    throw error;
  }
};

export const getProjects = async (value: any = {}) => {
  try {
    const query = buildQueryString(value)
    const response = await api.get(`/projects?${query}`);
    return response.data;
  } catch (error) {
    console.error('Error creating uproject:', error);
    throw error;
  }
};

export const getProject = async (id: string) => {
  try {
    const response = await api.get(`/projects/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error getting project:', error);
    throw error;
  }
};

export const updateProject = async (data: any) => {
  try {
    const response = await api.put(`/projects/${data.id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating project:', error);
    throw error;
  }
};

export const uploadAttachment = async (data: any) => {
  try {
    const {name, file, projectId, onUploadProgress} = data;
    const formData = new FormData();
    formData.append('file', file);
    if (name) {
      formData.append('name', name);
    }

    const response = await axios.post(`/projects/${projectId}/attachments`, formData, {
      baseURL: API_BASE_URL,
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
      },
      onUploadProgress,
    });

    return response.data;
    
  } catch (error) {
    console.error('Error uploading attachment:', error);
    throw error;
  }
}

export const getAttachments = async (projectId: string) => {
  try {
    const response = await api.get(`/projects/${projectId}/attachments`);
    return response.data;
  } catch (error) {
    console.error('Error getting attachments:', error);
    throw error;
  }
}

export const updateAttachment = async (data: any) => {
  try {
    const response = await api.put(`/projects/${data.parent}/attachments/${data.id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating project:', error);
    throw error;
  }
}

export const deleteAttachment = async (data: any) => {
  try {
    const {projectId, attachmentId} = data;

    const response = await api.delete(`/projects/${projectId}/attachments/${attachmentId}`);

    return response.data;
    
  } catch (error) {
    console.error('Error uploading attachment:', error);
    throw error;
  }
}

export const uploadGutterAttachment = async (data: any) => {
  try {
    console.log("UPLOAD ATTACHMENT", data);
    const {file, projectId, onUploadProgress} = data;
    const formData = new FormData();
    formData.append('file', file);

    const response = await axios.post(`/projects/${projectId}/gutterAttachments`, formData, {
      baseURL: API_BASE_URL,
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
      },
      onUploadProgress,
    });

    return response.data;
    
  } catch (error) {
    console.error('Error uploading attachment:', error);
    throw error;
  }
}

export const getGutterAttachments = async (projectId: string) => {
  try {
    const response = await api.get(`/projects/${projectId}/gutterAttachments`);
    return response.data;
  } catch (error) {
    console.error('Error getting attachments:', error);
    throw error;
  }
}

export const deleteGutterAttachment = async (data: any) => {
  try {
    console.log("UPLOAD ATTACHMENT", data);
    const {projectId, attachmentId} = data;

    const response = await api.delete(`/projects/${projectId}/gutterAttachments/${attachmentId}`);

    return response.data;
    
  } catch (error) {
    console.error('Error uploading attachment:', error);
    throw error;
  }
}

export const uploadSupplementAttachment = async (data: any) => {
  try {
    console.log("UPLOAD ATTACHMENT", data);
    const {file, projectId, supplementId, onUploadProgress} = data;
    const formData = new FormData();
    formData.append('file', file);

    const response = await axios.post(`/projects/${projectId}/supplements/${supplementId}/attachments`, formData, {
      baseURL: API_BASE_URL,
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
      },
      onUploadProgress,
    });

    return response.data;
    
  } catch (error) {
    console.error('Error uploading attachment:', error);
    throw error;
  }
}

export const getSupplementAttachments = async (data: any) => {
  try {
    const {projectId, supplementId} = data;

    const response = await api.get(`/projects/${projectId}/supplements/${supplementId}/attachments`);
    return response.data;
  } catch (error) {
    console.error('Error getting attachments:', error);
    throw error;
  }
}
